import { CONTRACT_STATUS } from "@/lib/advertising";

export function StatusBadge({ status, testid }) {
  const m = CONTRACT_STATUS[status] || CONTRACT_STATUS["No Contract"];
  const Icon = m.icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap ${m.cls}`} data-testid={testid}>
      <Icon className="h-3 w-3" aria-hidden="true" />{status}
    </span>
  );
}
